import { useState } from 'preact/hooks';
import { cart, cartCount, cartPositions, cartTotal, clearCart, removeAt, updateQty } from '@/store/cart';
import { navigate } from '@/router';
import { numberFormat } from '@/utils/format';
import { ProductModal } from '@/features/catalog/ProductModal.jsx';
import { QtyWidget } from '@/ui/QtyWidget.jsx';
import { CheckoutModal } from './CheckoutModal.jsx';
import { isMobile } from '@/lib/viewport';
import css from './CartPage.module.css';

export function CartPage() {
  const [openCheckout, setOpenCheckout] = useState(false);
  const [productSku, setProductSku] = useState(null);

  if (cart.value.length === 0) {
    return (
      <section class={`panel ${css.empty}`}>
        <div class={css.emptyIcon}>🛒</div>
        <h3>Корзина пуста</h3>
        <p>Добавьте товары из каталога</p>
        <button class="btn btn-primary" type="button" onClick={() => navigate('search')}>
          Перейти к поиску
        </button>
      </section>
    );
  }

  const footer = (
    <div class={css.footer}>
      <div class={css.total}>
        Итого: <span>{numberFormat(cartTotal.value)} ₽</span> ({cartPositions.value} поз.,{' '}
        {cartCount.value} шт.)
      </div>
      <div class={css.actions}>
        <button
          class="btn btn-secondary"
          type="button"
          onClick={() => {
            if (confirm('Очистить корзину?')) clearCart();
          }}
        >
          Очистить
        </button>
        <button class="btn btn-primary" type="button" onClick={() => setOpenCheckout(true)}>
          Оформить заказ
        </button>
      </div>
    </div>
  );

  if (isMobile.value) {
    return (
      <>
        <section class="panel">
          <h2 class="panel-title">Корзина</h2>
          <div class={css.cardList}>
            {cart.value.map((item, index) => (
              <div key={item.productId || item.externalId || item.sku} class={css.itemCard}>
                <button type="button" class={css.itemName} onClick={() => setProductSku(item.sku)}>
                  {item.name}
                </button>
                <div class={css.itemSku}>{item.sku}</div>
                <div class={css.itemRow}>
                  <span class={css.itemPrice}>{numberFormat(item.price)} ₽/шт.</span>
                  <button
                    type="button"
                    class={css.removeBtn}
                    onClick={() => removeAt(index)}
                    aria-label="Удалить"
                  >
                    <i class="fa-solid fa-trash-can" />
                  </button>
                </div>
                <div class={css.itemRow}>
                  <QtyWidget value={item.quantity} max={999} onChange={(qty) => updateQty(index, qty)} />
                  <strong class={css.itemSum}>{numberFormat(item.price * item.quantity)} ₽</strong>
                </div>
              </div>
            ))}
          </div>
          {footer}
        </section>
        {openCheckout && <CheckoutModal onClose={() => setOpenCheckout(false)} />}
        {productSku && <ProductModal sku={productSku} onClose={() => setProductSku(null)} />}
      </>
    );
  }

  return (
    <>
      <section class="panel">
        <h2 class="panel-title">Корзина</h2>
        <div class={css.tableWrap}>
          <table class={css.table}>
            <thead>
              <tr>
                <th>Товар</th>
                <th>Цена</th>
                <th>Количество</th>
                <th>Сумма</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {cart.value.map((item, index) => (
                <tr key={item.productId || item.externalId || item.sku}>
                  <td>
                    <button
                      type="button"
                      class={css.itemName}
                      onClick={() => setProductSku(item.sku)}
                    >
                      {item.name}
                    </button>
                    <div class={css.itemSku}>{item.sku}</div>
                  </td>
                  <td>{numberFormat(item.price)} ₽</td>
                  <td>
                    <QtyWidget
                      value={item.quantity}
                      max={999}
                      onChange={(qty) => updateQty(index, qty)}
                    />
                  </td>
                  <td>
                    <strong>{numberFormat(item.price * item.quantity)} ₽</strong>
                  </td>
                  <td>
                    <button
                      type="button"
                      class={css.removeBtn}
                      onClick={() => removeAt(index)}
                      aria-label="Удалить"
                      title="Удалить"
                    >
                      ✕
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {footer}
      </section>

      {openCheckout && <CheckoutModal onClose={() => setOpenCheckout(false)} />}
      {productSku && <ProductModal sku={productSku} onClose={() => setProductSku(null)} />}
    </>
  );
}
